import { InputText } from '../../InputText';

import styles from './FormListName.module.scss';

import type { NamePlaceholders } from '../../../../types/NamePlaceholders';
import type { FC, ChangeEventHandler } from 'react';

type FormListNameProps = {
  familyNameLabel: string;
  givenNameLabel: string;
  placeholders: NamePlaceholders;
  handleChangeFamilyName?: ChangeEventHandler<HTMLInputElement>;
  handleChangeGivenName?: ChangeEventHandler<HTMLInputElement>;
  familyNameDefaultValue?: string;
  givenNameDefaultValue?: string;
};

export const FormListName: FC<FormListNameProps> = ({
  familyNameLabel,
  givenNameLabel,
  placeholders,
  handleChangeFamilyName,
  handleChangeGivenName,
  familyNameDefaultValue,
  givenNameDefaultValue,
}) => (
  <div>
    <span className={styles.text}>{familyNameLabel}</span>
    <InputText
      name="familyName"
      id="familyName"
      type="text"
      width="short"
      placeholder={placeholders.familyName}
      onChange={handleChangeFamilyName}
      defaultValue={familyNameDefaultValue}
    />
    <span className={styles.text}>{givenNameLabel}</span>
    <InputText
      name="givenName"
      id="givenName"
      type="text"
      width="short"
      placeholder={placeholders.givenName}
      onChange={handleChangeGivenName}
      defaultValue={givenNameDefaultValue}
    />
  </div>
);
